import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import * as SC from "./styles";

export const Loading = ({ isCompetitorsTrafficShare }: { isCompetitorsTrafficShare?: boolean }) => {
    const renderLoaderContent = () => (
        <SC.LoaderItem>
            <SC.LoadingShare>
                <PixelPlaceholderLoader
                    height={12}
                    width={124}
                />
                <PixelPlaceholderLoader
                    height={24}
                    width={124}
                />
            </SC.LoadingShare>

            <PixelPlaceholderLoader
                height={125}
                width="100%"
            />
        </SC.LoaderItem>
    );

    const renderCompetitorsLoading = () => (
        <Stack
            alignItems="start"
            justifyContent="start"
            gap="4px"
        >
            <PixelPlaceholderLoader
                height={40}
                width={90}
            />

            <PixelPlaceholderLoader
                height={20}
                width={150}
            />

            <PixelPlaceholderLoader
                height={20}
                width={100}
            />
        </Stack>
    );

    return (
        <SC.LoadingContainer $isGrid={isCompetitorsTrafficShare}>
            {isCompetitorsTrafficShare ? renderCompetitorsLoading() : renderLoaderContent()}
        </SC.LoadingContainer>
    );
};
